<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="640px">
      <v-card class="grid">
        <v-card width="100%" class="pl-5 pr-4 mt-4" flat>
          <v-row no-gutters>
            <v-col cols="12" class="d-flex flex-row justify-space-between">
              <span class="title">{{
                $t('message.pages.users.warningDelete.title')
              }}</span>
              <v-btn icon @click="handleClose">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <span>
                {{ $t('message.pages.users.warningDelete.description') }}
              </span>
            </v-col>
          </v-row>
        </v-card>
        <!-- steps -->
        <v-card-text class="my-4 pa-0 px-5">
          <v-row no-gutters>
            <v-col cols="12">
              {{ $t('message.pages.users.warningDelete.textUsers') }}
              <br />
              <span v-for="(user, i) in usersWithRole" :key="i">
                &nbsp; &nbsp; <b>-{{ user.email }}</b> <br />
              </span>
              <br />
            </v-col>
          </v-row>
        </v-card-text>
        <!-- actions -->
        <v-card-actions class="px-6 py-6">
          <v-row no-gutters justify="center" align="center">
            <v-spacer />
            <v-btn color="primary" class="ml-2" @click="handleClose">
              {{ $t('message.continue') }}
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'WarningDeleteRole',
  components: {},
  data: () => ({
    open: false,
    usersWithRole: [],
  }),
  computed: {},
  mounted() {
    this.$root.$on('openWarningDeleteRole', (users) => {
      this.usersWithRole = users
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('openWarningDeleteRole')
  },
  methods: {
    handleClose() {
      this.open = false
    },
    handleMoreDetails() {
      this.moreDetails = true
    },
  },
  trimAllFields() {
    Object.keys(this.addUser).forEach(
      (e) => (this.addUser[e] = this.addUser[e].trim())
    )
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  font-size: 18px;
  color: var(--v-brand-darken2);
}
.fieldsTitle {
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  color: var(--v-neutral-lighten1);
}

.bg-dark,
.theme--dark {
  &::v-deep {
    .title {
      color: #8fb1e3;
    }
  }
}
</style>
